<template>
  <div class="flex flex-col h-full">
    <div class="flex items-center gap-1 px-6 pl-4 py-4">
      <button @click="goBack" class="flex items-center px-2">
        <span class="material-symbols-outlined">arrow_back</span>
      </button>
      <h1>{{ element?.name }}</h1>
    </div>
    <FigureAnnotator v-if="element" :element="element" :children="children" />
  </div>
</template>

<script setup lang="ts">
import { useRoute, useRouter } from "vue-router";
import FigureAnnotator from "./FigureAnnotator.vue";
import { RouteName } from "router";
import { useFunctionalElementsState } from "states/functionalElements";
import { computed } from "vue";

const elements = useFunctionalElementsState();

const router = useRouter();

const route = useRoute();

const element = computed(() =>
  elements.value.find((el) => el.id === route.params.id)
);

const children = computed(() =>
  elements.value.filter((el) => el.parentElementId === route.params.id)
);

function goBack() {
  router.push({
    name: RouteName.FUNCTIONAL_ELEMENTS_GRAPH,
  });
}
</script>
